import { caseStudies } from "../data/mock";
import { CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const CaseStudies = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Case Studies
            </h1>
            <p className="text-blue-100 text-lg md:text-xl max-w-3xl mx-auto">
              Real-world success stories showcasing measurable results and transformative impact
            </p>
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-20">
            {caseStudies.map((study, index) => (
              <div
                key={study.id}
                className="bg-white rounded-2xl shadow-xl overflow-hidden"
              >
                <div className="grid md:grid-cols-2">
                  <div className={`relative h-96 ${index % 2 === 1 ? "md:order-2" : ""}`}>
                    <img
                      src={study.image}
                      alt={study.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent" />
                    <div className="absolute bottom-6 left-6">
                      <span className="bg-white text-blue-900 px-4 py-2 rounded-full text-sm font-semibold">
                        {study.client}
                      </span>
                    </div>
                  </div>

                  <div className={`p-8 md:p-12 ${index % 2 === 1 ? "md:order-1" : ""}`}>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                      {study.title}
                    </h2>
                    <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                      {study.description}
                    </p>

                    <div className="space-y-6">
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                          <span className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-3">
                            <span className="text-red-600 text-lg">⚠</span>
                          </span>
                          Challenge
                        </h3>
                        <p className="text-gray-600 leading-relaxed ml-11">
                          {study.challenge}
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                          <span className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                            <span className="text-blue-600 text-lg">💡</span>
                          </span>
                          Solution
                        </h3>
                        <p className="text-gray-600 leading-relaxed ml-11">
                          {study.solution}
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                          <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                            <CheckCircle size={18} className="text-green-600" />
                          </span>
                          Results
                        </h3>
                        <div className="space-y-2 ml-11">
                          {study.results.map((result, idx) => (
                            <div key={idx} className="flex items-start">
                              <CheckCircle
                                size={18}
                                className="text-green-600 mr-2 flex-shrink-0 mt-0.5"
                              />
                              <span className="text-gray-700">{result}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="pt-4">
                        <h4 className="text-sm font-semibold text-gray-500 mb-2">
                          Technologies Used:
                        </h4>
                        <div className="flex flex-wrap gap-2">
                          {study.technologies.map((tech, idx) => (
                            <span
                              key={idx}
                              className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-sm font-medium"
                            >
                              {tech}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Create Your Success Story?
          </h2>
          <p className="text-blue-100 text-lg mb-8">
            Let's discuss how we can deliver similar transformative results for your business
          </p>
          <Link to="/contact">
            <Button className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 text-lg font-semibold rounded-lg shadow-2xl">
              Start Your Project
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
